import {Component, Input, ViewChild, Output, EventEmitter, OnChanges, OnDestroy, AfterViewInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {InterviewStreamService} from './services/interview.service';
import {InterviewDataService} from './services/interview-data.service';
import {GlobalService} from "../../common/services/global.service";
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ShareInterviewComponent} from './share-interview.component';
import {DeleteInterviewComponent} from './delete-interview.component';
import {UntypedFormGroup, FormControl, UntypedFormBuilder, Validators} from '@angular/forms';
import {Question} from '../../models/Question';
import {Interview} from '../../models/Interview';
import {VgApiService} from "@videogular/ngx-videogular/core";

@Component({
    selector: 'replay-responses',
    templateUrl: './replay-responses.component.html',
    styleUrls: ['./replay-responses.component.css'],
    standalone: false
})
export class ReplayResponseListComponent implements OnChanges, OnDestroy, AfterViewInit {

    form: UntypedFormGroup;

    @Input() currentAttempt: any;
    @Output() getQuestion: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('media', {static: false}) stream: any;
    @ViewChild('playback', {static: false}) playback: any;
    responseApi: VgApiService;
    playbackApi: VgApiService;
    autoplay: boolean;
    answers: boolean;
    repeat: boolean;
    questionTotal: any;
    questions: Question[];
    attempt:any;
    currentIndex: number = 0;
    currentItem: any;
    ratingClicked: number;
    itemIdRatingClicked: string;
    interview_title: string;
    reviewer: any = false;
    requested: any = false;
    playing: any = false;
    responseVideoSelected: boolean;
    subscriptions: Subscription[] = [];

    constructor(private _videoService: InterviewStreamService,
                public _dataService: InterviewDataService,
                public globalService: GlobalService,
                private _activatedRoute: ActivatedRoute,
                private _route: Router,
                private modalService: NgbModal,
                private fb: UntypedFormBuilder) {
    }

    ngOnChanges() {
        if (this.currentAttempt) {
            this.startPlayback();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    ngAfterViewInit() {
        let self = this;
        if (this._dataService.practice) {
            this.stream.nativeElement.play();
            const responseApiSub = this.responseApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                    this.playback.nativeElement.play();
                    this.playing = false;
                }
            );

            const playbackApiSub = this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                    this.interviewComplete();
                }
            );

            if (responseApiSub) {
                this.subscriptions.push(responseApiSub);
            }
            if (playbackApiSub) {
                this.subscriptions.push(playbackApiSub);
            }
            
        } else {
            this.updateResponseState({autoplay: false, answers: false, repeat: false});
        }
    }

    startPlayback() {
        this.currentIndex = this.currentIndex || 0;
        this.attempt = this.currentAttempt;
        this.interview_title = this.attempt.video_interview.title;
        this.questions = this.attempt.questions;
        this.questionTotal = (this._dataService.practice) ? 1 : this.questions.length;
        this._dataService.attemptId = this.attempt.video_interview_attempt_id;
        this.loadQuestion(this.currentIndex);
    }

    onPlayerReady(api: VgApiService) {
        this.responseApi = api;
    }

    onPlaybackReady(api: VgApiService) {
        this.playbackApi = api;
    }

    interviewComplete() {
        this._route.navigate(['../practice-complete'], {relativeTo: this._activatedRoute});
        return;
    }

    prevQuestion() {
        if (!this.questions[this.currentIndex - 1])
            return;
        this.currentIndex = (this.repeat) ? this.currentIndex : this.currentIndex -= 1;
    }

    nextQuestion() {
        if (!this.questions[this.currentIndex + 1] || this._dataService.practice)
            return;
        this.currentIndex = (this.repeat) ? this.currentIndex : this.currentIndex += 1;
    }

    loadQuestion(idx = this.currentIndex) {

        if (idx !== 0 && (!this.questions[idx] || !this.questions[idx] || this._dataService.practice))
            return;

        let video;
        this.currentIndex = idx;
        this.currentItem = this.questions[idx];
        this.sendCurrentQuestionToParent(this.currentItem);
        if (this.stream) {
            this.stream.nativeElement.src = (!this.answers) ? this.currentItem.question_file : '';
        }
        if (this.playback) {
            this.playback.nativeElement.src = this.currentItem.answer_file;
        }
        this.playing = (!this.answers);
    }

    updateResponseState(state) {

        // will eventually move to a separate service when time permits

        this._dataService.updateResponseState(state);
        this._dataService.reviewStates.pipe(take(1)).subscribe(states => {
            this.autoplay = states.autoplay;
            this.answers = states.answers;
            this.repeat = states.repeat;

            this.subscriptions.forEach(sub => sub.unsubscribe());
            this.subscriptions = [];

            if (this.answers) {
                this.responseVideoSelected = true;
            }

            let playbackApiSub = null;
            let responseApiSub = null;
            if (this.autoplay) {
                if (this.answers) {
                    this.playing = false;
                    this.playback?.nativeElement.play();
                    playbackApiSub = this.playbackApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.playing = false;
                        this.playback?.nativeElement.pause();
                    });
                } else {
                    this.playing = true;
                    this.responseVideoSelected = false;
                    this.stream?.nativeElement.play();
                    responseApiSub = this.responseApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.responseVideoSelected = true;
                        this.playback?.nativeElement.play();
                        this.playing = false;
                    });
                    playbackApiSub = this.playbackApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.playing = true;
                        this.stream?.nativeElement.pause();
                        this.responseVideoSelected = false;
                    });
                }
            } else {
                if (this.answers) {
                    responseApiSub = this.responseApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.playing = true;
                        this.playback?.nativeElement.load();
                    });
                } else {
                    responseApiSub = this.responseApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.playing = false;
                        this.playback?.nativeElement.load();
                    });
                    playbackApiSub = this.playbackApi.getDefaultMedia()?.subscriptions.ended.subscribe(() => {
                        this.playing = true;
                        this.stream?.nativeElement.load();
                    });
                }
            }

            if (playbackApiSub) {
                this.subscriptions.push(playbackApiSub);
            }
            if (responseApiSub) {
                this.subscriptions.push(responseApiSub);
            }
        });
    }

    sendCurrentQuestionToParent(question) {
        this.getQuestion.emit(question);
    }

    onQuestionVideoSelected() {
        this.responseVideoSelected = false;
    }

    onResponseVideoSelected() {
        this.responseVideoSelected = true;
    }

}
